module.exports = __webpack_public_path__ + "img/American_Credit_Business_Loans_Competitive_Rates.a099b26.png";